import {
  useIsMobile,
  WSAvatar,
  WSCard,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSImage,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { Benefit } from "../../data";
import { selectorBenefitCostLabel } from "../../selectors/selectorBenefitCostLabel";
import styles from "./index.module.scss";

const DEFAULT_LOGO_WIDTH = 48;
const FALLBACK_ICON = "heart";

type Props = {
  benefit: Benefit;
  isEnrolled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
};

export const BenefitCard: React.FC<Props> = props => {
  const isMobile = useIsMobile();
  const { benefit } = props;

  const avatar = (
    <WSAvatar.Icon
      icon={benefit.icon || FALLBACK_ICON}
      size="L"
      color={benefit.iconColor || "blue500"}
      colorBackground={benefit.iconBackgroundColor || "blue50"}
    />
  );

  return (
    <WSCard
      data-testid={`benefit-${benefit.slug}`}
      shimmer={props.isLoading}
      onClick={props.onClick}
      mt="L"
      p="L"
    >
      <WSFlexBox
        direction={isMobile ? "column" : "row"}
        justify="space-between"
        alignContent={isMobile ? "flex-start" : "center"}
        alignItems={isMobile ? "flex-start" : "center"}
        wrap="nowrap"
        gap="M"
      >
        <WSFlexBox.CenterY
          wrap="nowrap"
          className={styles.nameSection}
          pr="2XL"
          gap="XL"
        >
          {benefit.logoUrl ? (
            <WSImage
              placeholder={avatar}
              src={benefit.logoUrl}
              width={benefit.logoWidth || DEFAULT_LOGO_WIDTH}
            />
          ) : (
            avatar
          )}

          <WSElement>
            <WSText.Heading5>{benefit.name}</WSText.Heading5>
            <WSText.ParagraphXs color="gray500" mt="XS">
              {benefit.atAGlance}
            </WSText.ParagraphXs>
          </WSElement>
        </WSFlexBox.CenterY>

        {!benefit.hideCost && (
          <WSElement className={styles.costSection}>
            {props.isEnrolled ? (
              <WSPill theme="blue" badge text="Enrolled" />
            ) : (
              <WSText.ParagraphSm>
                Cost: {selectorBenefitCostLabel(benefit)}
              </WSText.ParagraphSm>
            )}
          </WSElement>
        )}

        {!isMobile && (
          <WSFlexBox className={styles.chevronSection} justify="flex-end">
            <WSIcon block name="chevron-right" color="blue500" />
          </WSFlexBox>
        )}
      </WSFlexBox>
    </WSCard>
  );
};
